angular.module('lf.common')

.directive('validName', function (validationService) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, el, attrs, model) {
      var validator = function (val) {
        var valid = model.$isEmpty(val) || validationService.validateName(val);
        model.$setValidity('name', valid);
        return val;
      }
      model.$parsers.push(validator);
      model.$formatters.push(validator);
    }
  }
});
